export const WALKOVER_NONE = 0;
export const WALKOVER_GUEST_FORFEIT = 1;
export const WALKOVER_HOME_FORFEIT = 2;

export const normalizeWalkover = (value) => {
    const parsed = Number(value);
    if (parsed === WALKOVER_GUEST_FORFEIT) return WALKOVER_GUEST_FORFEIT;
    if (parsed === WALKOVER_HOME_FORFEIT) return WALKOVER_HOME_FORFEIT;
    return WALKOVER_NONE;
};

export const isWalkover = (value) => normalizeWalkover(value) !== WALKOVER_NONE;

export const getWalkoverLabel = (walkover) => {
    const mode = normalizeWalkover(walkover);
    if (mode === WALKOVER_GUEST_FORFEIT) return 'Đội khách bỏ cuộc';
    if (mode === WALKOVER_HOME_FORFEIT) return 'Đội nhà bỏ cuộc';
    return '';
};
